import { TimeReportItem } from '../../../features/time-report/types';

export const getTimeReportItemTypeLabel = (item: TimeReportItem): string => item.typeName ?? '';

export const filterTimeReportItems = (
    items: TimeReportItem[] = [],
    search?: string,
    includeClientName = true,
    includeTypeName = false
): TimeReportItem[] => {
    if (!items.length) {
        return items;
    }

    const trimmed = search?.trim().toLowerCase() ?? '';
    if (!trimmed) {
        return items;
    }

    return items.filter((item) =>
        (item.employeeName ?? '').toLowerCase().includes(trimmed) ||
        (item.projectName ?? '').toLowerCase().includes(trimmed) ||
        (includeClientName && (item.clientName ?? '').toLowerCase().includes(trimmed)) ||
        (includeTypeName && getTimeReportItemTypeLabel(item).toLowerCase().includes(trimmed))
    );
};
